import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEO
        title="韩漫免费_漫画在线阅读_好看的韩国漫画下拉式-韩漫网站"
        description="在韩漫网站上可以免费阅读各种韩国漫画，享受流畅的下拉式在线体验，发现众多好看作品，无需注册即可随时随地沉浸于漫画世界"
        keywords="免费韩漫,在线漫画阅读,下拉式韩国漫画,韩漫网站"
        canonicalUrl="https://www.hanmanworld.com/"
      />

      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "韩漫世界",
          "url": "https://www.hanmanworld.com/",
          "description": "免费韩国漫画在线阅读平台，提供海量韩漫资源，流畅的下拉式阅读体验",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.hanmanworld.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "韩漫世界",
          "url": "https://www.hanmanworld.com/",
          "description": "专注于韩国漫画免费在线阅读的中文平台",
          "sameAs": []
        })}
      </script>

      <main>
        <HeroSection />
        <HotComics />
        <CategoryGrid />
        <LatestArticles />
        <FAQSection />
      </main>
    </>
  );
}